import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';

const RebelnetConfigView = () => {
  const [allowedLists, setAllowedLists] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const config = await api.getRebelnetConfig();
      setAllowedLists(config.allowedLists?.join('\n') || '');
    } catch (error) {
      console.error('Error loading config:', error);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage('');
    try {
      const lists = allowedLists
        .split('\n')
        .map(l => l.trim())
        .filter(Boolean)
        .filter(l => /^\d+$/.test(l));
      
      if (lists.length === 0) {
        setMessage('error:Inserisci almeno un ID lista valido (solo numeri)');
        setLoading(false);
        return;
      }
      
      await api.saveRebelnetConfig({ allowedLists: lists });
      setAllowedLists(lists.join('\n'));
      setMessage('success:Configurazione salvata con successo');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('error:Errore nel salvataggio: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const [msgType, msgText] = message ? message.split(':') : ['', ''];

  return (
    <div className="settings">
      <h2>Configurazione Rebelnet</h2>
      <p style={{ fontSize: '0.85rem', color: 'var(--color-gray-500)', marginBottom: 'var(--space-sm)' }}>
        Inserisci gli ID delle liste autorizzate (uno per riga, solo numeri). Solo i contratti con list_id presente in questo elenco verranno salvati e notificati.
      </p>
      
      <textarea
        value={allowedLists}
        onChange={(e) => setAllowedLists(e.target.value)}
        placeholder={"18569\n18570\n18571"}
        className="config-textarea"
      />
      
      <button className="btn-primary" onClick={handleSave} disabled={loading} style={{ marginTop: 'var(--space-md)' }}>
        {loading ? 'Salvataggio...' : 'Salva Configurazione'}
      </button>
      
      {message && (
        <div className={`config-message ${msgType}`}>
          {msgText}
        </div>
      )}
    </div>
  );
};

export default RebelnetConfigView;
